import React, { useState } from "react";
import { 
  // Breadcrumbs, 
  SearchFundCard 
} from "@hedgefund/shared";
import {
  Input,
  Button,
  // DropDown,
  Spinner,
  NoDataFound,
} from "@public/ui-toolkit";
import ReactModal from "@public/ui-toolkit/src/ReactModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ReactDropDown from "@public/ui-toolkit/src/ReactSelect";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "180px",
    backgroundColor: "#3ac1b5",
    border: "#3ac1b5",
    padding: 4,
  }),
  option: (base, state) => ({
    ...base,
    height: "100%",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#fff",
  }),
  singleValue: (provided) => ({ ...provided, color: "#fff" }),
  input: (styles) => ({ ...styles, color: "#fff" }),
};

const Funds = ({
  searchValue,
  handleSearch,
  CreateRecommendFund,
  rmfundLoading,
  filterStrategyShow,
  dashboardState,
  aum,
  strategyFilter,
  onClickCrossStrategyHandler,
  onClickCrossAumHandler,
  onChangeFilterData,
  aumData,
  fundState,
  getNumberWithUnit,
  onChangeAumData,
  filterAUMShow,
  regionDropDown,
  onChangeReigionData,
  followFundHandler,
  defaultValue,
  filterRegionShow,
  onClickCrossRegionHandler,
  regionFilter,
  value2,
  monthlyReturn,
  onClickNext,
  filterMonthlyReturnShow,
  onChangeMonthlyReturn,
  onClickCrossMonthlyReturnHandler,
  subSpecialtyDropDown,
  filterSubSpecialtyShow,
  onChangeSubSpecialtyFilterData,
  onClickCrossSubSpecialtyHandler,
  subSpecialtyFilter,
  getAllocatorUsers,
  userLoading = false,
  allocatorUsers = [],
  createRoom,
}) => {
  // const phoneRegExp = /^\+[0-9]{11,16}/;
  
  const [open, setOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const formik = useFormik({
    initialValues: {
      hedgeFundName: "",
      contactName: "",
      emailAddress: "",
      phoneNumber: "",
      website: "",
      message: "",
    },
    validationSchema: Yup.object({
      hedgeFundName: Yup.string().required("Hedge Fund Name is required"),
      contactName: Yup.string(),
      emailAddress: Yup.string(),
      phoneNumber: Yup.string(),
      message: Yup.string(),
    }),
    onSubmit: (values) => {
      CreateRecommendFund(values, onCloseModal);
    },
  });
  return (
    <>
      <main>
        <div className="main-inner">
          <div className="container mt-5">
            <div>
              <h4 className="stylish-title text-blue">Funds</h4>
            </div>
            <div className="mt-4">
              <div className="search-with-btn" style={{ marginLeft: "25%" }}>
                <form>
                  <div className="col-8 mr-3">
                    <Input
                      defaultValue={searchValue}
                      placeholder="Search"
                      label="Search"
                      type="text"
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </div>

                  {/* <div className="col-2">
                    <Button btnName="Search" btnType="!primary" />
                  </div> */}
                </form>
              </div>
              <div className="d-flex">
                {filterStrategyShow && (
                  <div className="mt-3 mr-3">
                    <span className="mr-2 ">
                      Strategy:
                      {
                        // strategyFiltser
                        dashboardState.filter(
                          (s) => s.id === parseInt(strategyFilter)
                        )[0]?.name
                      }
                    </span>

                    <button
                      className="close-btn"
                      onClick={onClickCrossStrategyHandler}
                    >
                      x
                    </button>
                  </div>
                )}

                {filterAUMShow && (
                  <div className="mt-3  mr-3">
                    <span className="mr-2 ">Aum: {filterAUMShow?.label}</span>
                    <button 
                      className="close-btn"
                      onClick={onClickCrossAumHandler}
                    >
                      X
                    </button>
                  </div>
                )}
                {Boolean(filterMonthlyReturnShow) && (
                  <div className="mt-3  mr-3">
                    <span className="mr-2 ">
                      Monthly Return: {filterMonthlyReturnShow?.label}
                    </span>
                    <button
                      className="close-btn"
                      onClick={onClickCrossMonthlyReturnHandler}
                    >
                      X
                    </button>
                  </div>
                )}
                {filterRegionShow && (
                  <div className="mt-3">
                    <span className="mr-2 ">
                      Region:{" "}
                      {
                        regionDropDown.filter(
                          (s) => s.id === parseInt(regionFilter)
                        )[0]?.name
                      }
                    </span>

                    <button
                      className="close-btn"
                      onClick={onClickCrossRegionHandler}
                    >
                      x
                    </button>
                  </div>
                )}

                {filterSubSpecialtyShow && (
                  <div className="mt-3">
                    <span className="mr-2 ">
                      Substrategy:
                      {
                        subSpecialtyDropDown.filter(
                          (s) => s.id === parseInt(subSpecialtyFilter)
                        )[0]?.name
                      }
                    </span>

                    <button
                      className="close-btn"
                      onClick={onClickCrossSubSpecialtyHandler}
                    >
                      x
                    </button>
                  </div>
                )}
              </div>
              <div className="bs4-row justify-content-center mt-4">
                <div className="px-2 mb-3">
                  <ReactDropDown
                    styles={customStyles}
                    selectedValue={
                      strategyFilter > 0
                        ? {
                            value: strategyFilter,
                            label: dashboardState.filter(
                              (s) => s.id === parseInt(strategyFilter)
                            )[0]?.name,
                          }
                        : { value: "Strategies", label: "Strategies" }
                    }
                    onChange={onChangeFilterData}
                    performanceMetrcisResult={dashboardState?.map((item) => ({
                      value: item.id,
                      label: item.name,
                      isdisabled: item.isExistFund,
                    }))}
                  />
                </div>

                <div className="px-2 mb-3">
                  <ReactDropDown
                    styles={customStyles}
                    selectedValue={
                      subSpecialtyFilter > 0
                        ? {
                            value: subSpecialtyFilter,
                            label: subSpecialtyDropDown.filter(
                              (s) => s.id === parseInt(subSpecialtyFilter)
                            )[0]?.name,
                          }
                        : { value: "Sub-Strategy", label: "Sub-Strategy" }
                    }
                    onChange={onChangeSubSpecialtyFilterData}
                    performanceMetrcisResult={subSpecialtyDropDown?.map(
                      (item) => ({
                        value: item.id,
                        label: item.name,
                        isdisabled: item.isExistFund,
                      })
                    )}
                  />
                </div>
                <div className="px-2 mb-3">
                  <ReactDropDown
                    styles={customStyles}
                    selectedValue={
                      filterAUMShow
                        ? filterAUMShow
                        : { value: "AUM", label: "AUM" }
                    }
                    onChange={onChangeAumData}
                    performanceMetrcisResult={aumData?.map((item) => ({
                      value: item.value,
                      label: item.option,
                    }))}
                  />
                </div>
                <div className="px-2 mb-3">
                  <ReactDropDown
                    styles={customStyles}
                    selectedValue={
                      regionFilter > 0
                        ? {
                            value: regionFilter,
                            label: regionDropDown.filter(
                              (s) => s.id === parseInt(regionFilter)
                            )[0]?.name,
                          }
                        : { value: "Region", label: "Region" }
                    }
                    onChange={onChangeReigionData}
                    performanceMetrcisResult={regionDropDown?.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                  />
                </div>
                <div className="px-2 mb-3">
                  <ReactDropDown
                    styles={customStyles}
                    selectedValue={
                      filterMonthlyReturnShow
                        ? filterMonthlyReturnShow
                        : { value: "Yearly Return", label: "Yearly Return" }
                    }
                    onChange={onChangeMonthlyReturn}
                    performanceMetrcisResult={monthlyReturn?.map((item) => ({
                      value: item.value,
                      label: item.option,
                    }))}
                  />
                </div>
              </div>
            </div>
            <div className="mt-5">
              <div className="row gy-4">
                {fundState?.hedgefunds?.length ? (
                  fundState?.hedgefunds?.map((fund, index) => (
                    <div className="col-xl-3 col-lg-4 col-md-6" key={index}>
                      <SearchFundCard
                        // btnName={fund.followed ? "Followed" : "Follow"}
                        portalUrl = {"hedgefund"}
                        getAllocatorUsers ={getAllocatorUsers}
                        userLoading = {userLoading}
                        createRoom={createRoom}
                        allocatorUsers={allocatorUsers}
                        fund={fund}
                        getNumberWithUnit={getNumberWithUnit}
                        followFundHandler={followFundHandler}
                      />
                    </div>
                  ))
                ) : (
                  // <span>No fund found!</span>
                  <NoDataFound message="No Activity Found!" />
                )}
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <ul className="fund-pagination mt-5">
              <li className="page-item">
                {fundState.loading ? (
                  <Spinner className="text-center" />
                ) : (
                  <a
                    className="page-link"
                    disabled={fundState?.hedgefunds?.length >= fundState.total}
                    href
                    onClick={onClickNext}
                  >
                    Load More
                  </a>
                )}
              </li>
            </ul>
          </div>
          <div style={{ textAlign: "center" }} className="container mt-5">
            <p>
              Please contact us, if you would like to recommend a fund to join
              FCN
            </p>
            <Button
              className="justify-content-center"
              btnType={"primary"}
              btnName={"Refer a Hedge Fund"}
              onClick={onOpenModal}
            />
          </div>
        </div>
        <ReactModal
          open={open}
          onClose={onCloseModal}
          center
          title={"Refer a Fund"}
        >
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-body">
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-12">
                    <label>Hedge Fund Name *</label>
                    <Input
                      type="text"
                      id="hedgeFundName"
                      name="hedgeFundName"
                      placeholder="HedgeFund Name"
                      onChange={(e) => e.target.value}
                      {...formik.getFieldProps("hedgeFundName")}
                    />
                    {formik.touched.hedgeFundName &&
                    formik.errors.hedgeFundName ? (
                      <div className="form-error-message">
                        {" "}
                        {formik.errors.hedgeFundName}{" "}
                      </div>
                    ) : null}
                  </div>
                  <div className="col-lg-6">
                    <label> Contact Name</label>
                    <Input
                      type="text"
                      id="contactName"
                      name="contactName"
                      placeholder="Contact Name"
                      onChange={(e) => e.target.value}
                      {...formik.getFieldProps("contactName")}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label> Email Address</label>
                    <Input
                      type="text"
                      id="emailAddress"
                      name="emailAddress"
                      placeholder="Email Address"
                      onChange={(e) => e.target.value}
                      {...formik.getFieldProps("emailAddress")}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label> Website Url</label>
                    <Input
                      type="text"
                      id="website"
                      name="website"
                      placeholder="Website"
                      onChange={(e) => e.target.value}
                      {...formik.getFieldProps("website")}
                    />
                  </div>
                  <div className="col-lg-6" style={{ position: "relative" }}>
                    <label>Phone Number</label>
                    <PhoneInput
                      country={"us"}
                      placeholder={"Phone Number"}
                      inputStyle={{ width: "275px" }}
                      value={phoneNumber}
                      onChange={(phone) => {
                        formik.setFieldValue("phoneNumber", `+${phone}`);
                        setPhoneNumber(`+${phone}`);
                      }}
                    />
                  </div>
                  <div className="col-lg-12">
                    <label> Message</label>
                    <textarea
                      className="form-control"
                      id="message"
                      rows="6"
                      placeholder="Message"
                      onChange={(e) => e.target.value}
                      {...formik.getFieldProps("message")}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block text-center">
              <Button
                btnName="Submit"
                btnType="primary"
                loading={rmfundLoading}
                type="submit"
                onClose={rmfundLoading ? onCloseModal : ""}
              />
            </div>
          </form>
        </ReactModal>
      </main>
    </>
  );
};

export default Funds;
